import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_HR_GET_LAST_PASSWORD_CHANGE,
  MY_HR_LAST_PASSWORD_CHANGE_SUBSCRIPTION,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrLastPasswordChange = ({ email }: { email: string }) => {
  const { data, loading, error } = useQuery(MY_HR_GET_LAST_PASSWORD_CHANGE, {
    skip: !email,
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    variables: {
      email,
    },
  });

  const { data: subsData } = useSubscription(
    MY_HR_LAST_PASSWORD_CHANGE_SUBSCRIPTION,
    {
      fetchPolicy: "network-only",
      skip: !email,
      variables: {
        email,
      },
    },
  );

  return {
    data: subsData?.lastPasswordChange || data?.lastPasswordChange,
    loading,
    error,
  };
};

export default useMyHrLastPasswordChange;
